<template>
  <div id="app">
    <!-- 使用Element UI的加载组件 -->
    <el-loading 
      v-if="loading" 
      text="正在加载权限菜单..." 
      fullscreen 
      :background="'rgba(255, 255, 255, 0.8)'"
    />
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapState(['loading'])
  }
}
</script>

<style scoped>
/* 不需要额外的样式，Element UI的el-loading已经提供了美观的样式 */
</style>
